var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scoreWarp" },
    [
      _c("div", { staticClass: "navLine" }, [
        _c("div", { staticClass: "infoNav" }, [
          _c("span", { staticClass: "left20" }, [
            _vm._v("作品/课程名称：" + _vm._s(_vm.worksMsg.workName)),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("比赛组别：" + _vm._s(_vm.worksMsg.groupName))]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rightNav" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.isBack } },
              [_vm._v("返回作品列表")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "marTop20" }, [_vm._v("作品信息")]),
      _vm._v(" "),
      _c("el-row", { staticClass: "worksMainWarp majCenter" }, [
        _c("div", { staticClass: "designInfo" }, [
          _c(
            "div",
            { staticClass: "infoItem" },
            [
              _c("span", { staticClass: "labelSpan" }, [
                _vm._v("作品/课程名称："),
              ]),
              _vm._v(" "),
              _c("el-tooltip", { attrs: { placement: "top" } }, [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _vm._v(_vm._s(_vm.worksMsg.workName)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "valSpan" }, [
                  _vm._v(_vm._s(_vm.worksMsg.workName)),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "infoItem" },
            [
              _c("span", { staticClass: "labelSpan" }, [_vm._v("所属学校：")]),
              _vm._v(" "),
              _c("el-tooltip", { attrs: { placement: "top" } }, [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _vm._v(_vm._s(_vm.worksInfo.schoolName)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "valSpan" }, [
                  _vm._v(_vm._s(_vm.worksInfo.schoolName)),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "infoItem" },
            [
              _c("span", { staticClass: "labelSpan" }, [_vm._v("所属组别：")]),
              _vm._v(" "),
              _c("el-tooltip", { attrs: { placement: "top" } }, [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _vm._v(_vm._s(_vm.worksMsg.groupName)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "valSpan" }, [
                  _vm._v(_vm._s(_vm.worksMsg.groupName)),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "infoItem" },
            [
              _c("span", { staticClass: "labelSpan" }, [_vm._v("审核状态：")]),
              _vm._v(" "),
              _c("el-tooltip", { attrs: { placement: "top" } }, [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _vm._v(_vm._s(_vm._f("getStatus")(_vm.worksMsg.status))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "valSpan" }, [
                  _vm._v(_vm._s(_vm._f("getStatus")(_vm.worksMsg.status))),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "infoItem" },
            [
              _c("span", { staticClass: "labelSpan" }, [_vm._v("审核专家：")]),
              _vm._v(" "),
              _c("el-tooltip", { attrs: { placement: "top" } }, [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _vm._v(_vm._s(_vm.worksMsg.experts)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "valSpan" }, [
                  _vm._v(_vm._s(_vm.worksMsg.experts)),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "infoItem" },
            [
              _c("span", { staticClass: "labelSpan" }, [_vm._v("最终得分：")]),
              _vm._v(" "),
              _c("el-tooltip", { attrs: { placement: "top" } }, [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _vm._v(_vm._s(_vm.worksMsg.score)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "valSpan" }, [
                  _vm._v(_vm._s(_vm.worksMsg.score)),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "infoItem" },
            [
              _c("span", { staticClass: "labelSpan" }, [_vm._v("专业大类：")]),
              _vm._v(" "),
              _c("el-tooltip", { attrs: { placement: "top" } }, [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _vm._v(_vm._s(_vm.worksMsg.majorName)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "valSpan" }, [
                  _vm._v(_vm._s(_vm.worksMsg.majorName)),
                ]),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "scoreView" },
          _vm._l(_vm.worksMsg.matchWorkContentListVoList, function (item, j) {
            return _c(
              "el-row",
              { key: j, staticClass: "viewWarp" },
              [
                _c("el-tooltip", { attrs: { placement: "top" } }, [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(_vm._s(item.contentName)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "labelSpanX" }, [
                    _vm._v(_vm._s(item.contentName) + "："),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "scoreViewItem" },
                  [
                    item.contentFileType === "mp4"
                      ? [
                          _c("video", {
                            attrs: { controls: "", src: item.content },
                          }),
                        ]
                      : item.contentFileType === "url"
                      ? [
                          _c("span", [
                            _c(
                              "a",
                              {
                                attrs: { href: item.content, target: "_blank" },
                              },
                              [_vm._v(_vm._s(item.content))]
                            ),
                          ]),
                        ]
                      : item.contentFileType === "input"
                      ? [
                          _c("span", [
                            _c("a", { attrs: { href: item.content } }, [
                              _vm._v(_vm._s(item.content)),
                            ]),
                          ]),
                        ]
                      : item.contentFileType === "textArea"
                      ? [
                          _c("span", [
                            _c("a", { attrs: { href: item.content } }, [
                              _vm._v(_vm._s(item.content)),
                            ]),
                          ]),
                        ]
                      : item.contentFileType === "jpg"
                      ? [
                          _c("el-image", {
                            attrs: {
                              src: item.content,
                              "preview-src-list": [item.content],
                            },
                          }),
                        ]
                      : item.contentFileType === "pdf" ||
                        item.contentFileType === "xls" ||
                        item.contentFileType === "doc"
                      ? [
                          _c("el-image", {
                            attrs: {
                              src: item.viewUrl,
                              "preview-src-list": _vm.photoList,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.getViewList(item.content)
                              },
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                item.contentFileType != "textArea" &&
                item.contentFileType != "input" &&
                item.contentFileType != "url"
                  ? _c(
                      "div",
                      { staticClass: "downLoadBtn" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.downLoadFile(item.content)
                              },
                            },
                          },
                          [_vm._v("下载")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grade" }, [
        _c(
          "div",
          { staticClass: "cebox" },
          [
            _c(
              "el-form",
              { attrs: { model: _vm.gradeForm } },
              [
                _c("div", { staticClass: "tableBox fx" }, [
                  _c("div", { staticClass: "tableTitle" }, [
                    _vm._v("评分标准："),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tables" }, [
                    _c(
                      "table",
                      [
                        _c("tr", [
                          _c("th", { attrs: { colspan: "1" } }, [
                            _vm._v("评分项"),
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { colspan: "1" } }, [
                            _vm._v("评分内容"),
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { colspan: "1" } }, [
                            _vm._v("评分要素"),
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { colspan: "1" } }, [
                            _vm._v("满分"),
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { colspan: "1" } }, [
                            _vm._v("得分"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.gradeTable, function (i, j) {
                          return _c("tr", { key: j }, [
                            _c("td", [_vm._v(_vm._s(i.scoringName))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(i.scoringContent))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(i.scoringElement))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(i.scoringScore))]),
                            _vm._v(" "),
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: i.actualScore,
                                    expression: "i.actualScore",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  onkeyup:
                                    "this.value=this.value.replace(/\\D/g, '')",
                                },
                                domProps: { value: i.actualScore },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        i,
                                        "actualScore",
                                        $event.target.value
                                      )
                                    },
                                    function ($event) {
                                      return _vm.input(i.actualScore)
                                    },
                                  ],
                                },
                              }),
                            ]),
                          ])
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "totalNum" }, [
                      _c("span", [_vm._v("总分：")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.gradeForm.totalScore))]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "violation fx" }, [
                  _c("div", { staticClass: "tableTitle" }, [
                    _vm._v("作品资料中是否存在否决性指标："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "radioBox", staticStyle: { width: "100%" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            multiple: "",
                            filterable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.isViolation,
                            callback: function ($$v) {
                              _vm.isViolation = $$v
                            },
                            expression: "isViolation",
                          },
                        },
                        _vm._l(_vm.isViolationOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "opinion fx" },
                  [
                    _c("div", { staticClass: "tableTitle" }, [
                      _vm._v("审核意见："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        maxlength: "120",
                        rows: 2,
                        "show-word-limit": "",
                        placeholder: "请输入审核意见",
                      },
                      model: {
                        value: _vm.gradeForm.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.gradeForm, "content", $$v)
                        },
                        expression: "gradeForm.content",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "alertMsg fx" }, [
                  _c("div", { staticClass: "tableTitle" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n            作品资料中如果存在否决性指标，此作品为“0分”评审结束。\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-col",
                  { staticClass: "submit", attrs: { span: 24 } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.btnEnable },
                        on: { click: _vm.submit },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.submitBtnText) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "pubDia",
          attrs: {
            title: "待审核列表",
            visible: _vm.dialogVisible,
            width: "60%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("ZhjySerach", {
            attrs: { queryGroup: _vm.queryGroup, modelData: _vm.modelData },
            on: {
              "update:modelData": function ($event) {
                _vm.modelData = $event
              },
              "update:model-data": function ($event) {
                _vm.modelData = $event
              },
              search: _vm.search,
            },
          }),
          _vm._v(" "),
          _c("ZhjyTable", {
            attrs: {
              minWidth: _vm.minWidth,
              tableData: _vm.listData,
              columList: _vm.defaultColumn,
              isShowSelection: true,
              options: _vm.options,
              pageNum: _vm.page.pageNumber,
              pageSize: _vm.page.pageSize,
            },
            on: {
              "update:pageNum": function ($event) {
                return _vm.$set(_vm.page, "pageNumber", $event)
              },
              "update:page-num": function ($event) {
                return _vm.$set(_vm.page, "pageNumber", $event)
              },
              handleSelectionChange: _vm.handleSelectionChange,
              auditScore: _vm.auditScore,
            },
          }),
          _vm._v(" "),
          _c("ZhjyPagination", {
            attrs: {
              pageNum: _vm.page.pageNumber,
              pageSize: _vm.page.pageSize,
              total: _vm.totalData,
            },
            on: {
              "update:pageNum": function ($event) {
                return _vm.$set(_vm.page, "pageNumber", $event)
              },
              "update:page-num": function ($event) {
                return _vm.$set(_vm.page, "pageNumber", $event)
              },
              handleCurrentChange: _vm.handleCurrentChange,
              handleSizeChange: _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }